import { render } from "./EditarDespesas.vue?vue&type=template&id=4515a34d&scoped=true"
import script from "./EditarDespesas.vue?vue&type=script&lang=js"
export * from "./EditarDespesas.vue?vue&type=script&lang=js"

import "./EditarDespesas.vue?vue&type=style&index=0&id=4515a34d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4515a34d"]])

export default __exports__